import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { userInformation } from 'recoil/atom/authentication';
import { menuData } from 'constant/menuData';
import MenuItem from 'components/Layout/ApplicationLayout/SidebarMenu/Mobile/Menu/MenuItem';

const Menu = () => {
  const { role } = useRecoilValue(userInformation);
  const listMenu = useMemo(() => {
    return menuData[role];
  }, [role]);

  return (
    <div className="menu">
      {listMenu?.map((itemMenu, index) => {
        return <MenuItem key={index} menu={itemMenu} />;
      })}
    </div>
  );
};

export default Menu;
